const CPF_WEIGHTS_1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
const CPF_WEIGHTS_2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const normalizeDocument = (raw) => (raw == null ? '' : String(raw).toUpperCase().replace(/[^0-9A-Z]/g, ''));

const calculateCheckDigit = (value, weights) => {
  const soma = weights.reduce((acc, peso, i) => acc + (value.charCodeAt(i) - 48) * peso, 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

const isAllCharsEqual = (value) => value.split('').every((c) => c === value[0]);

export const validateDocument = (raw) => {
  const clean = normalizeDocument(raw);

  if (/^[0-9]{11}$/.test(clean) && !isAllCharsEqual(clean)) {
    const base9 = clean.slice(0, 9);
    const dv1 = calculateCheckDigit(base9, CPF_WEIGHTS_1);
    const base10 = base9 + dv1;
    const dv2 = calculateCheckDigit(base10, CPF_WEIGHTS_2);
    if (String(dv1) === clean[9] && String(dv2) === clean[10]) {
      return { document: clean, type: 'cpf' };
    }
  }

  if (/^[0-9A-Z]{12}[0-9]{2}$/.test(clean) && !isAllCharsEqual(clean)) {
    const base12 = clean.slice(0, 12);
    const dv1 = calculateCheckDigit(base12, CNPJ_WEIGHTS_1);
    const base13 = base12 + dv1;
    const dv2 = calculateCheckDigit(base13, CNPJ_WEIGHTS_2);
    if (String(dv1) === clean[12] && String(dv2) === clean[13]) {
      return { document: clean, type: 'cnpj' };
    }
  }

  return null;
};

const maskCpf = (clean) => clean
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

const maskCnpj = (clean) => clean
  .replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2')
  .replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3')
  .replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2')
  .replace(/([0-9A-Z]{4})(\d{1,2})$/, '$1-$2');

export const maskDocument = (raw) => {
  const clean = normalizeDocument(raw);
  if (!clean) return '';
  if (clean.length <= 11) {
    return maskCpf(clean);
  }
  return maskCnpj(clean.slice(0, 14));
};
